// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bp-b";
export var colorBlue = "_bp-8";
export var colorDot = "_bp-0";
export var colorDotLarge = "_bp-2";
export var colorDotSmall = "_bp-1";
export var colorGreen = "_bp-7";
export var colorGrey = "_bp-3";
export var colorOrange = "_bp-5";
export var colorPink = "_bp-a";
export var colorPurple = "_bp-9";
export var colorRed = "_bp-4";
export var colorYellow = "_bp-6";